export default __webpack_public_path__ + "assets/images/Mask group.png";